var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-default",staticStyle:{"margin-top":"15px"}},[_c('el-button',{class:{'button-default-disabled': _vm.disabled},staticStyle:{"margin-top":"0"},style:(_vm.estiloBotao),attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }